import React, { useState, useEffect, useRef } from 'react';
import OpenedSidebar from '../../components/openedSidebar';
import { connect } from 'react-redux';
import { dashboardActions } from '../../redux-utils/actions/dashboard-actions';
import Loader from '../../components/Loader';
import ArchiveView from '../../components/views/ArchiveView';
import { useAuth } from '../../custom-hooks/useAuth';
import { useSelector } from 'react-redux';
import ClosedSidebar from '../../components/closedSidebar';

const { allParticipantAction } = dashboardActions;

function ArchiveData({ allParticipantResult }) {
    const data = allParticipantResult?.allParticipantData || [];
    const isOpened = useSelector((state) => state.sidebarState.isOpen);

    if (
        allParticipantResult.allParticipantData &&
        allParticipantResult.allParticipantData.length > 0
    ) {
        return (
            <ArchiveView
                data={data}
                allParticipantResult={allParticipantResult}
            />
        );
    }

    return allParticipantResult.status === '' ||
        allParticipantResult.status === 'all_participant_fetch_start' ? (
        <div className="bg-[#F9F9F9] font-sans flex">
            {isOpened ? <OpenedSidebar /> : <ClosedSidebar />}
            <Loader />
        </div>
    ) : (
        <ArchiveView data={data} allParticipantResult={allParticipantResult} />
    );
}

const areEqual = (prevProps, nextProps) => {
    return (
        prevProps.allParticipantResult.allParticipantData ===
        nextProps.allParticipantResult.allParticipantData
    );
};
const ArchiveMemo = React.memo(ArchiveData, areEqual);

function Archive(props) {
    const { allParticipantDispatchAction, allParticipantResult } = props;

    const [currentResult, setCurrentResult] = useState([]);

    useEffect(() => {
        setCurrentResult(allParticipantResult);
    }, [allParticipantResult]);

    return (
        <>
            <ArchiveMemo
                allParticipantDispatchAction={allParticipantDispatchAction}
                // singleParticipantDispatchAction={singleParticipantDispatchAction}
                allParticipantResult={currentResult}
            />
        </>
    );
}

const mapStateToProps = (state) => ({
    allParticipantResult: state.dashboardState,
});

const mapDispatchToProps = (dispatch) => ({
    allParticipantDispatchAction: (param) =>
        dispatch(allParticipantAction(param)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Archive);
